module.exports = __webpack_public_path__ + "img/merchantMgt.a12a3528.svg";